import { render, staticRenderFns } from "./PersonName.vue?vue&type=template&id=0ee3a26e&scoped=true&"
import script from "./PersonName.vue?vue&type=script&lang=js&"
export * from "./PersonName.vue?vue&type=script&lang=js&"
import style0 from "./PersonName.vue?vue&type=style&index=0&id=0ee3a26e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee3a26e",
  null
  
)

export default component.exports